import * as Sentry from "@sentry/angular";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const tracesSampleRate = environment.sentry?.tracesSampleRate ?? (environment.production ? 0.1 : 0);

Sentry.init({
    dsn: environment.sentry?.dsn || "https://89314d74fbb344f4a410c01e0dbb52b9@glitchtip.statementzen.com/1",
    release: `statementzen-fe@${environment.version}`,
    integrations: tracesSampleRate > 0 ? [Sentry.browserTracingIntegration()] : [],
    tracesSampleRate,
    debug: environment.sentry?.debug ?? false,
    environment: environment.sentry?.environment || (environment.production ? 'production' : 'development'),
    initialScope: {
        tags: { platform: 'frontend' },
    },
})

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.error(err);
    Sentry.captureException(err);
  });
